import React,{useEffect,useRef}from "react";
import {Box,Typography}from "@mui/material";
import BenefitsFeature from "./benefitFeatures.js";
import "./benefits.css";

import decentralizedImage from "../../../../static/Images/benefits/decenterlized.png";
import fairImage from "../../../../static/Images/benefits/fair.png";
import globalImage from "../../../../static/Images/benefits/global-access.png";
import payoutsImage from "../../../../static/Images/benefits/instant-payouts.png";
import gamesImage from "../../../../static/Images/benefits/wide-game-selection.png";
import communityImage from "../../../../static/Images/benefits/community-driven.png";

import {setupBenefitsAnimation}from "../animations";

const benefitsFeatures=[
  {
    title:"Decentralized",
    mainDescription:"A truly player-owned platform powered by blockchain, giving you freedom, transparency, and full control.",
    description:"Built on blockchain with smart contracts.",
    image:decentralizedImage,
  },
  {
    title:"Provably Fair",
    mainDescription:"Every game is powered by transparent technology, allowing players to verify results and trust the outcome.",
    description:"Every result is verifiable on-chain.",
    image:fairImage,
  },
  {
    title:"Global Access",
    mainDescription:"Play from anywhere in the world, connecting players across the globe through a truly accessible gaming platform.",
    description:"Play from anywhere in the world.",
    image:globalImage,
  },
  {
    title:"Instant Payouts",
    mainDescription:"Get your winnings directly in your wallet without unnecessary delays, keeping every payout fast and transparent.",
    description:"Winnings are sent directly to your wallet.",
    image:payoutsImage,
  },
  {
    title:"Wide Game Selection",
    mainDescription:"Explore a growing collection of lotteries, slots, originals, and more, all available within one platform.",
    description:"Lotteries, slots, originals and more.",
    image:gamesImage,
  },
  {
    title:"Community Driven",
    mainDescription:"Built around the players, AutoBET grows with its community and creates a gaming experience shaped by the people who use it.",
    description:"Built by players, for players.",
    image:communityImage,
  },
];

const Benefits=()=>{
  const sectionRef=useRef(null);
  const introRef=useRef(null);

  useEffect(()=>{
    const cleanup=setupBenefitsAnimation(
      sectionRef,
      introRef
    );

    return cleanup;
  },[]);

  return(
    <Box
      id="benefits"
      component="section"
      className="home-benefits"
      ref={sectionRef}
    >
      <Box className="benefits-container">

        <Box
          ref={introRef}
          className="benefits-intro"
        >
          <Typography
            component="p"
            className="benefits-kicker"
          >
            BUILT BY PLAYERS. POWERED BY BLOCKCHAIN.
          </Typography>

          <Typography
            component="h2"
            className="benefits-title"
          >
            Why AutoBET?
          </Typography>

          <Typography
            component="p"
            className="benefits-description"
          >
            Explore the features that make AutoBET transparent,
            accessible, and built for a global community of players.
          </Typography>
        </Box>

        <Box className="benefits-cards-wrapper">
          <Box className="benefits-cards">
            {benefitsFeatures.map((feature,index)=>(
              <BenefitsFeature
                key={feature.title}
                number={index+1}
                title={feature.title}
                mainDescription={feature.mainDescription}
                description={feature.description}
                image={feature.image}
              />
            ))}
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Benefits;